import React from 'react'

const FailedLogin = () => {
    return (
        <div>
            <h1>Your login attempt failed. Please go back and try again.</h1>
        </div>
    )
}

export default FailedLogin